import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { change as changeAction, FormName, formValueSelector } from 'redux-form';

const withFormValues = (WrappedComponent) =>
  function (props) {
    const dispatch = useDispatch();
    const change = useCallback((...args) => dispatch(changeAction(...args)), [dispatch]);
    return (
      <FormName>
        {({ form, sectionPrefix }) => {
          const changeFormField = useCallback((field, value) => change(form, field, value), [form]);
          const fieldValueSelector = useCallback(
            (...args) =>
              (state) =>
                formValueSelector(form)(state, ...args),
            [form],
          );
          return (
            <WrappedComponent
              {...props}
              changeFormField={changeFormField}
              fieldValueSelector={fieldValueSelector}
              form={form}
              sectionPrefix={sectionPrefix}
            />
          );
        }}
      </FormName>
    );
  };

export default withFormValues;
